import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-security-check',
  templateUrl: './security-check.component.html',
  styleUrls: ['./security-check.component.sass']
})
export class SecurityCheckComponent implements OnInit {
  @Input() forgotPasawordStatus;
  @Output() updateView = new EventEmitter<number>();
  public typeNotification='';
  public on=false;
  constructor() { }

  ngOnInit() {
  }
  continue(){
    if(this.typeNotification=='sms/email'){
      this.updateView.emit(31);
    }
    else if(this.typeNotification=='questions'){
      this.updateView.emit(32);
    }
  }
  onKey(value){
    if(this.typeNotification!=''){
      this.on=true;
    }
  }
}
